(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const contactForms = document.querySelectorAll('.contact-form__form');

    contactForms.forEach((contactForm) => {
      const firstInvalidField = contactForm.querySelector('[aria-invalid="true"]');

      if (firstInvalidField) {
        firstInvalidField.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
